import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';
import { Link } from 'react-router-dom';


// Helpers de formulário
import InputMask from 'react-input-mask';
import Select from 'react-select';
import { Modal } from 'react-bootstrap';


// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { Tabs, Tab, Dropdown, DropdownButton, MenuItem } from 'react-bootstrap';

import TrainingCertificationsModal from './TrainingCertificationsModal';
import TrainingCertificationsModalView from './TrainingCertificationsModalView';

class TrainingCertificationsTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      training_id: this.props.training_id,
      date_start_str: this.props.training_data.date_start_str,
      date_finish_str: this.props.training_data.date_finish_str,
      signatures_select: [],
      certifications: [],
      certification_groups: [],
      certification_suppliers: [],
      certification_suppliers_modal: '',
      modal_group_certifications: false,
      certification_id: '',
      certification_group_id: '',
      certification_supplier_id: '',
      modal_props: false,
      training_certifications: [],
      staffs: [],
      instructors_data: '',
      certification_group_certifications: {},
      training_certification: {},
      training_certification_staffs: '',
      c_hours: '',
      total_hours: '',
      updated: 0,
    };

    //bind específico
    this.add = this.add.bind(this);
    this.delete = this.delete.bind(this);
    this.editModal = this.editModal.bind(this);
    this.viewModal = this.viewModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.closeModalParent = this.closeModalParent.bind(this);
    this.closeModalViewParent = this.closeModalViewParent.bind(this);
    this.updateDataModal = this.updateDataModal.bind(this);
    this.updateInstructors = this.updateInstructors.bind(this);
    this.export = this.export.bind(this);
    this.saveCertificationGroups = this.saveCertificationGroups.bind(this);
  }
  // Handlers
  handleChangeModal (key, name, event) {
    var updatedCertifications = [...this.state.certification_group_certifications];
    updatedCertifications[key][name] = event.target.value;

    this.setState({ certification_group_certifications: updatedCertifications });
  }

  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleSelectChangeModal(key, name, event) {
    var change = {};
    var updatedCertifications = [...this.state.certification_group_certifications];
    if(event == null) {
      updatedCertifications[key][name] = null;
    } else {
      updatedCertifications[key][name] = event.value;
    }

    this.setState({ certification_group_certifications: updatedCertifications });
  }

  handleSelectChangeSupplierModal(key, name, event) {
    var updatedCertifications = [...this.state.certification_group_certifications];
    if(event == null) {
      updatedCertifications[key][name] = null;
    } else {
      updatedCertifications[key][name] = event.value;
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/verificar/fornecedor/validade/' + event.value , { method: 'GET', mode: 'cors', headers: value}).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          if (responseJson.status === 'error') {
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          } else {
            self.props.handleAlert('', '', 'closed');
          }
        });
      });
    }
    this.setState({ certification_group_certifications: updatedCertifications });
  }

  handleSelectChangeSupplier(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;

      var header = this.refs.request_api.header('application/json');
      var self = this;
      if (event.value !== null) {
        this.props.handleAlert('', '', 'open');
        Promise.resolve(header).then(function(value) {
          fetch(config.get('api') + '/verificar/fornecedor/validade/' + event.value , { method: 'GET', mode: 'cors', headers: value}).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            if (responseJson.status === 'error') {
              self.props.handleAlert(responseJson.message, responseJson.status, 'open');
            } else {
              self.props.handleAlert('', '', 'closed');
            }
          });
        });
      }
    }
    this.setState(change);
  }

  handleSelectChangeCertificationGroup(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
      var header = this.refs.request_api.header('application/json');
      var self = this;
      this.props.handleAlert('', '', 'open');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/agrupamento/certificado/certificados/modal/' + event.value , { method: 'GET', mode: 'cors', headers: value}).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.setState({
            certification_group_certifications: responseJson.data.main,
            signatures_select: responseJson.data.signatures_select,
            modal_group_certifications: true
          });
          self.props.handleAlert(responseJson.message, responseJson.status, 'closed');
        });
      });
    }
    this.setState(change);
  }
  handleSelectChangeCertification(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;

      var header = this.refs.request_api.header('application/json');
      var self = this;
      if (event.value !== null) {
        this.props.handleAlert('', '', 'open');
        Promise.resolve(header).then(function(value) {
          fetch(config.get('api') + '/certificado/fornecedores/lista/' + event.value , { method: 'GET', mode: 'cors', headers: value}).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            self.setState({
              certification_suppliers: responseJson.data.certification_supplier,
              variable_signatures: responseJson.data.variable_signatures,
              signatures_select: responseJson.data.signatures_select,
            });
            self.props.handleAlert(responseJson.message, responseJson.status, 'closed');
          });
        });
      }
    }
    this.setState(change);
  }

  // LM
  componentWillReceiveProps(newProps) {
    if((this.state.loaded === 0 && typeof newProps.training_data.name !== 'undefined' && Array.isArray(newProps.certifications) && Array.isArray(newProps.training_certifications) && Array.isArray(newProps.staffs) && Array.isArray(newProps.certification_groups))  || (this.state.loaded === 1 && newProps.updated === 1)) {
      this.setState({
        name: newProps.training_data.name,
        training_id: newProps.training_data.id,
        date_start_str: newProps.training_data.date_start_str,
        date_finish_str: newProps.training_data.date_finish_str,
        code: newProps.training_data.code,
        revision: newProps.training_data.revision,
        observations: newProps.training_data.observations,
        certifications: newProps.certifications,
        certification_groups: newProps.certification_groups,
        training_certifications: newProps.training_certifications,
        staffs: newProps.staffs,
        loaded: 1,
      });
    }
  }

  // Fetch salvando a edição
  add(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      training_id: this.state.training_id,
      date_start: this.state.date_start_str,
      date_finish: this.state.date_finish_str,
      certification_group_id: this.state.certification_group_id,
      certification_id: this.state.certification_id,
      certification_supplier_id: this.state.certification_supplier_id,
      c_hours: this.state.c_hours,
      variable_signatures: this.state.variable_signatures,
      top_right_signature_id: this.state.top_right_signature_id,
      top_left_signature_id: this.state.top_left_signature_id,
      bottom_right_signature_id: this.state.bottom_right_signature_id,
      bottom_left_signature_id: this.state.bottom_left_signature_id,
      total_hours: this.state.total_hours,
      presence_type: this.state.presence_type,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/treinamento/certificado', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.updateData(responseJson);
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  updateDataModal (responseJson) {
    var header = this.setState({updated: 1});
    var self = this;
    Promise.resolve(header).then(function(value) {
      self.editModal(responseJson);
    });
  }

  editModal (event) {
    if (this.state.updated == 0) {
      var training_certification_id = event.currentTarget.value;
      this.props.handleAlert('', '', 'open');
    } else {
      var training_certification_id = event.data.training_certification_id;
    }
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/treinamento/certificado/info/edicao/' + training_certification_id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          if (self.state.updated === 1) {
            self.props.handleAlert(event.message, event.status, 'open');
            self.setState({
              instructors_data: responseJson.data.instructors_data,
            });
          } else {
            self.setState({
              modal_props: true,
              instructors_data: responseJson.data.instructors_data,
              training_certification: responseJson.data.main,
              certification_suppliers_modal: responseJson.data.certification_suppliers,
              training_certification_id: training_certification_id
            });
            self.props.handleAlert('', '', 'closed');
          }
        } else {
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }
      });
    });
  }

  viewModal (event) {
    if (this.state.updated == 0) {
      var training_certification_id = event.currentTarget.value;
      this.props.handleAlert('', '', 'open');
    } else {
      var training_certification_id = event.data.training_certification_id;
    }
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/treinamento/certificado/instrutores/' + training_certification_id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({instructors_data: responseJson.data});
        }
      }).then(() => {
        self.setState({modal_props: true});
        self.props.handleAlert('', '', 'closed');
      });
    });
  }

  delete (event) {
    var training_certification_id = event.currentTarget.value;
    var confirm = window.confirm('Tem certeza que gostaria de deletar essa aula?');
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/treinamento/certificado/' + training_certification_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.props.updateData(responseJson);
          } else {
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  export(url) {
    var self = this;
    self.props.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          window.open(config.get('cdn') + '/tmp/' + responseJson.data);
        }
        self.props.handleAlert('', '', 'closed');
      });
    });
  }

  saveCertificationGroups(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      training_id: this.state.training_id,
      certification_group_certifications: this.state.certification_group_certifications,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/treinamento/certificado/agrupamentos', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.setState({modal_group_certifications: false});
        self.props.updateData(responseJson);
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  closeModal() {
    this.setState({modal_group_certifications: false});
  }

  closeModalParent() {
    var responseJson = {
      status: 'success',
      message: 'Os dados foram atualizados com sucesso',
    };
    this.props.handleAlert('', '', 'open');
    this.setState({modal_props: false, updated: 0}, this.props.updateData(responseJson));
  }

  closeModalViewParent() {
    this.setState({modal_props: false, updated: 0});
  }

  updateInstructors(data) {
    this.setState({instructors_data: data});
  }

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  {(self.props.status === 1 || self.props.status === 3) ?
    <div>
      <h3 className="page-title">Adicionar aula</h3>
      <hr/>
      <form onSubmit={this.add}>
        <div className="row">
          {!this.state.certification_id ? 
              <div className="col-md-6">
                <div className="form-group">
                  <label>Agrupamento:</label>
                  <Select
                    className="form-field-name"
                    name="certification_group_id"
                    value={this.state.certification_group_id}
                    searchable={true}
                    placeholder={'Selecionar agrupamento'}
                    onChange={this.handleSelectChangeCertificationGroup.bind(this, 'certification_group_id')}
                    options={this.state.certification_groups}
                    required
                  />
                </div>
              </div>
          : ""}
          {!this.state.certification_group_id ? 
            <div className="col-md-6">
              <div className="form-group">
                <label>Certificado:</label>
                <Select
                  className="form-field-name"
                  name="certification_id"
                  value={this.state.certification_id}
                  searchable={true}
                  placeholder={'Selecionar certificado'}
                  onChange={this.handleSelectChangeCertification.bind(this, 'certification_id')}
                  options={this.state.certifications}
                  required
                />
              </div>
            </div>
          : ""}
          {this.state.certification_id ? 
            <div className="col-md-6">
              <div className="form-group">
                <label>Fornecedor:</label>
                <Select
                  className="form-field-name"
                  name="certification_supplier_id"
                  value={this.state.certification_supplier_id}
                  searchable={true}
                  placeholder={'Selecionar fornecedor'}
                  onChange={this.handleSelectChangeSupplier.bind(this, 'certification_supplier_id')}
                  options={this.state.certification_suppliers}
                  required
                />
              </div>
            </div>
          :""}
        </div>
        {this.state.certification_id ?
          <div className="row">
          {this.state.variable_signatures ? 
            <div className="col-md-6 form-group">
              <label>Assinatura lado superior direito:</label>
              <Select
                className="form-field-name"
                name="top_right_signature_id"
                value={this.state.top_right_signature_id}
                searchable={true}
                placeholder={""}
                onChange={this.handleSelectChange.bind(this, 'top_right_signature_id')}
                options={this.state.signatures_select}
              />
            </div>
          : ""}
          {this.state.variable_signatures ? 
            <div className="col-md-6 form-group">
              <label>Assinatura lado inferior direito:</label>
              <Select
                className="form-field-name"
                name="bottom_right_signature_id"
                value={this.state.bottom_right_signature_id}
                searchable={true}
                placeholder={""}
                onChange={this.handleSelectChange.bind(this, 'bottom_right_signature_id')}
                options={this.state.signatures_select}
              />
            </div>
          : ""}
          {this.state.variable_signatures ? 
            <div className="col-md-6 form-group">
              <label>Assinatura lado superior esquerdo:</label>
              <Select
                className="form-field-name"
                name="top_left_signature_id"
                value={this.state.top_left_signature_id}
                searchable={true}
                placeholder={""}
                onChange={this.handleSelectChange.bind(this, 'top_left_signature_id')}
                options={this.state.signatures_select}
              />
            </div>
          : ""}
          {this.state.variable_signatures ? 
            <div className="col-md-6 form-group">
              <label>Assinatura lado inferior esquerdo:</label>
              <Select
                className="form-field-name"
                name="bottom_left_signature_id"
                value={this.state.bottom_left_signature_id}
                searchable={true}
                placeholder={""}
                onChange={this.handleSelectChange.bind(this, 'bottom_left_signature_id')}
                options={this.state.signatures_select}
              />
            </div>
          : ""}
          </div>
        : ""}

        {this.state.certification_id ?
          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <label>Data de início:</label>
                <InputMask value={this.state.date_start_str}  maskChar={null} name="date_start" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_start_str')} placeholder="Data de início" required />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label>Data de término:</label>
                <InputMask value={this.state.date_finish_str}  maskChar={null} name="date_finish_str " mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_finish_str')} placeholder="Data de término" required />
              </div>
            </div>
          </div>
        : ""}
        {this.state.certification_id ?
          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <label>Período:</label>
                <input value={this.state.c_hours} name="date_start" className="form-control" onChange={this.handleChange.bind(this, 'c_hours')} placeholder="Período da aula" />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label>Carga horária:</label>
                <input value={this.state.total_hours} name="date_start" className="form-control" onChange={this.handleChange.bind(this, 'total_hours')} placeholder="Carga horária da aula" />
              </div>
            </div>
          </div>
        : ""}
        {this.state.certification_id ?
          <div className="row">
            {self.props.status === 1 || self.props.status === 3 ? 
              <div className="col-md-6">
                <div className="form-group">
                  <label>{"Tipo de modalidade"}:</label>
                  <Select
                    className="form-field-name"
                    name="presence_type"
                    value={this.state.presence_type}
                    searchable={true}
                    placeholder={"Selecionar tipo de modalidade"}
                    onChange={this.handleSelectChange.bind(this, 'presence_type')}
                    options={[
                    {value: "presencial", label: "Presencial"},
                    {value: "ead", label: "EAD"}
                    ]}
                    required
                  />
                </div>
              </div>
              : ""
            }
          </div>
        : ""}
        {this.state.certification_id ?
          <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-plus"></i> Adicionar aula</button>
        : ""}
      </form>
      <hr/>
    </div>
  :
    ''
  }
  <h3 className="page-title">Lista de aulas</h3>
  <hr/>
  <table className="table table-bordered table-hover">
    <thead>
      <tr>
        <th className="text-center">Início</th>
        <th className="text-center">Fim</th>
        <th className="text-center">Certificado</th>
        <th className="text-center">Fornecedor</th>
        <th className="text-center">Modalidade</th>
        <th className="text-center">Ações</th>
      </tr>
    </thead>
    <tbody id="training-certification-staffs">
      {Object.keys(self.state.training_certifications).map(function(k) {
        return (
          <tr>
            <td className="text-center">{self.state.training_certifications[k].date_start_str}</td>
            <td className="text-center">{self.state.training_certifications[k].date_finish_str}</td>
            <td className="text-center">{self.state.training_certifications[k].certification.name}</td>
            <td className="text-center">{self.state.training_certifications[k].certification_supplier.supplier.name}</td>
            <td className="text-center">{self.state.training_certifications[k].presence_type_str}</td>
            <td className="col-md-3 text-center">
                {(self.props.status === 1 || self.props.status === 3) ?
                  <div className="btn-group">
                    <button className="btn btn-primary btn-sm" value={self.state.training_certifications[k].id} onClick={self.editModal}>
                      <i className="fa fa-fw fa-pencil"></i>
                    </button>
                    <button className="btn btn-sm btn-danger" value={self.state.training_certifications[k].id} onClick={self.delete}>
                      <i className="fa fa-fw fa-trash"></i>
                    </button>
                  </div>
                :
                  <button className="btn btn-info btn-sm" value={self.state.training_certifications[k].id} onClick={self.viewModal}>
                    <i className="fa fa-fw fa-eye"></i>
                  </button>
                }

                <Dropdown id="export-data">
                  <Dropdown.Toggle bsStyle={'warning btn-sm'}>
                    <i className="fa fa-fw fa-file-pdf-o"></i>
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <MenuItem header>Lista de presença</MenuItem>
                    <MenuItem onSelect={self.export} eventKey={'/treinamento/exportar/lista/presenca/'+self.state.training_certifications[k].id}>Lista de presença</MenuItem>
                    <MenuItem divider />
                    <MenuItem header>Avaliação de treinamento</MenuItem>
                    <MenuItem onSelect={self.export} eventKey={'/treinamento/exportar/avaliacao/treinamento/'+self.state.training_certifications[k].id}>Avaliação de treinamento</MenuItem>
                  </Dropdown.Menu>
                </Dropdown>
            </td>
          </tr>
        );
      })}
    </tbody>
  </table>
  <Modal show={this.state.modal_group_certifications} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
    <Modal.Header>
      <h4 className="pull-left">Preencher aula(s)/fornecedor(es)</h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={this.closeModal}>
      <i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
      <table className="table table-bordered table-hover">
        <thead>
          <tr>
            <th className="text-center">Certificado</th>
            <th className="text-center">Fornecedor</th>
            <th className="text-center">Início</th>
            <th className="text-center">Fim</th>
            <th className="text-center">Período</th>
            <th className="text-center">Carga horária</th>
            <th className="text-center">Tipo de modalidade</th>
            <th className="text-center">Cima esquerda</th>
            <th className="text-center">Cima direita</th>
            <th className="text-center">Baixo esquerda</th>
            <th className="text-center">Baixo direita</th>
          </tr>
        </thead>
        <tbody id="training-certification-staffs">
          {Object.keys(this.state.certification_group_certifications).map(function(k) {
            return (
              <tr>
                <td className="text-center">{self.state.certification_group_certifications[k].certification_name}</td>
                <td className="text-center">
                  <Select
                    className="form-field-name"
                    name="certification_supplier_id"
                    value={self.state.certification_group_certifications[k].certification_supplier_id}
                    searchable={true}
                    placeholder={'Selecionar fornecedor'}
                    onChange={self.handleSelectChangeSupplierModal.bind(self, k, 'certification_supplier_id')}
                    options={self.state.certification_group_certifications[k].certification_suppliers}
                    required
                  />
                </td>
                <td className="text-center">
                  <InputMask value={self.state.certification_group_certifications[k].date_start_str}  maskChar={null} name="date_start" mask="99/99/9999" className="form-control" onChange={self.handleChangeModal.bind(self, k, 'date_start_str')} placeholder="Data de início" required />
                </td>
                <td className="text-center">
                  <InputMask value={self.state.certification_group_certifications[k].date_finish_str}  maskChar={null} name="date_finish" mask="99/99/9999" className="form-control" onChange={self.handleChangeModal.bind(self, k, 'date_finish_str')} placeholder="Data de fim" required />
                </td>
                <td className="text-center">
                  <input value={self.state.certification_group_certifications[k].c_hours} name="c_hours" className="form-control" onChange={self.handleChangeModal.bind(self, k, 'c_hours')} placeholder="Período da aula" />
                </td>
                <td className="text-center">
                  <input value={self.state.certification_group_certifications[k].total_hours} name="total_hours" className="form-control" onChange={self.handleChangeModal.bind(self, k, 'total_hours')} placeholder="Carga horária da aula" />
                </td>
                <td className="text-center">
                  <Select
                    className="form-field-name"
                    name="presence_type"
                    value={self.state.certification_group_certifications[k].presence_type}
                    searchable={true}
                    placeholder={"Selecionar tipo de modalidade"}
                    onChange={self.handleSelectChangeModal.bind(self, k, 'presence_type')}
                    options={[
                      {value: "presencial", label: "Presencial"},
                      {value: "ead", label: "EAD"}
                    ]}
                    required
                  />
                </td>
                <td className="text-center">
                  {self.state.certification_group_certifications[k].variable_signatures == 1 ?
                    <Select
                      className="form-field-name"
                      name="top_left_signature_id"
                      value={self.state.certification_group_certifications[k].top_left_signature_id}
                      searchable={true}
                      placeholder={""}
                      onChange={self.handleSelectChangeModal.bind(self, k, 'top_left_signature_id')}
                      options={self.state.signatures_select}
                    />
                    : ""
                  }
                </td>
                <td className="text-center">
                  {self.state.certification_group_certifications[k].variable_signatures == 1 ?
                    <Select
                      className="form-field-name"
                      name="top_right_signature_id"
                      value={self.state.certification_group_certifications[k].top_right_signature_id}
                      searchable={true}
                      placeholder={""}
                      onChange={self.handleSelectChangeModal.bind(self, k, 'top_right_signature_id')}
                      options={self.state.signatures_select}
                    />
                    : ""
                  }
                </td>
                <td className="text-center">
                  {self.state.certification_group_certifications[k].variable_signatures == 1 ?
                    <Select
                      className="form-field-name"
                      name="bottom_left_signature_id"
                      value={self.state.certification_group_certifications[k].bottom_left_signature_id}
                      searchable={true}
                      placeholder={""}
                      onChange={self.handleSelectChangeModal.bind(self, k, 'bottom_left_signature_id')}
                      options={self.state.signatures_select}
                    />
                    : ""
                  }
                </td>
                <td className="text-center">
                  {self.state.certification_group_certifications[k].variable_signatures == 1 ?
                    <Select
                      className="form-field-name"
                      name="bottom_right_signature_id"
                      value={self.state.certification_group_certifications[k].bottom_right_signature_id}
                      searchable={true}
                      placeholder={""}
                      onChange={self.handleSelectChangeModal.bind(self, k, 'bottom_right_signature_id')}
                      options={self.state.signatures_select}
                    />
                    : ""
                  }
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <button onClick={this.saveCertificationGroups} className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> Salvar todos</button>
    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={this.closeModal}>
      <i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>
  {(self.props.status === 1 || self.props.status === 3) ?
    <TrainingCertificationsModal handleAlert={this.props.handleAlert} staffs={this.props.staffs} certifications={this.props.certifications} instructors_data={this.state.instructors_data} training_certification={this.state.training_certification} training_certification_id={this.state.training_certification_id} training_id={this.props.training_id}  certification_suppliers_modal={this.state.certification_suppliers_modal} modal_props={this.state.modal_props} updateData={this.props.updateData} closeModalParent={this.closeModalParent} updateDataModal={this.updateDataModal} status={self.props.status} date_start_str={this.state.date_start_str} date_finish_str={this.state.date_finish_str} />
  :
    <TrainingCertificationsModalView updateData={this.props.updateData} handleAlert={this.props.handleAlert} instructors_data={this.state.instructors_data} training_certification_id={this.state.training_certification_id} training_id={this.props.training_id} modal_props={this.state.modal_props} closeModalViewParent={this.closeModalViewParent} updateInstructors={this.updateInstructors} />
  }
</div>
    );
  }
}

export default TrainingCertificationsTab;



// WEBPACK FOOTER //
// ./src/Components/Trainings/Elements/TrainingCertificationsTab.js